export default __webpack_public_path__ + "static/2-b53e3a5402c885af7052322f92e6b2aa.png";